import React, { useEffect } from 'react';
import { api, apis } from 'api';
import { useLocation } from '@reach/router';
const eventApi = api.getEventApi();
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const UrlToWriteMail = () => {
    const locationHref = useLocation().href;
    useEffect(() => {
        if (!locationHref)
            return;
        const mailListString = locationHref.split('mailList=')[1];
        if (mailListString) {
            const mailList = mailListString.split('&')[0].split(',');
            mailApi.doWriteMailToContact([...mailList]);
        }
        console.log('location111 @qq.com', locationHref);
    }, [locationHref]);
    return React.createElement(React.Fragment, null);
};
export default UrlToWriteMail;
